module.exports = __webpack_public_path__ + "media/images/vp/icon.vk.white-60d01d5450848ca20517cdc887a89bba.png";